module.exports = __webpack_public_path__ + "img/RW.93766250.svg";